<div class="hw-box-content">
  <div class="hw-header-wrap">
    <div class="row">
      <div class="col-12">
        <div class="row">
          <div class="col-6">Alert Help Setup</div>
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-6 gap">
      <ul class="list-inline">
          <li class="align-top width-210px" >
            <fn-select [labelKey]="'name'" [inputKey]="'primaryKey'" [optionList]="productArray" (changeEvent)="getIdeno()"
              [placeholder]="'Select Product'" [(ngModel)]="selectProduct" [ngModelOptions]="{standalone: true}">
            </fn-select>
          </li>
          @if (selectProduct != null) {
          <li class="align-top width-500px">
        <fn-select [labelKey]="'idenNo'" [inputKey]="'idenNo'" [optionList]="idenNoArray"
        [placeholder]="'Select idenNo'" [(ngModel)]="selectIdenNo" (changeEvent)="onIdenNoChange()" 
        [ngModelOptions]="{standalone: true}"></fn-select></li>
        }
      </ul>
    </div>
  </div>
</div>
@if (selectIdenNo != null) {
<div class="hw-content">
  <div class="hw-header-wrap">
        <div class="row">
          <div class="col-11">Alert Help URL : </div>
          <div class=" col-1 align-end">
            <fn-button [type]="'success'" [btnClass]="'btn-sm btn-round'" [text]="'Save'"
              (click)="setAlertHelp()"></fn-button>
          </div>
        </div>      
  </div>
  <div class="hw-content">
    <div class="row">
      <div class="col-10">
        <fn-base-input placeholder="Enter Alert HelpURL" [(ngModel)]="objectHash.helpURL"
                    [ngModelOptions]="{standalone: true}"></fn-base-input>
      </div>
    </div>
  </div>
</div>
}


